import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getProductos_costos() {
    
    const InformesBD =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Campo_secciones/".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      InformesBD.push(doc.data());
    });
    console.log(InformesBD);
    return InformesBD;
    

}
